export default __webpack_public_path__ + "static/media/star-2.ced822d9.svg";